import { Link, useLocation } from "react-router-dom";
import { Store, Package, ReceiptText, Settings2 } from "lucide-react";
import { Badge } from "../ui/badge";
import { useLang } from "../../context/LanguageContext";

// Undermeny for Butikk-modulen i dashbordet: Oversikt/Varer · Ordrer · Innstillinger – med «Tilleggsmodul»-kicker (design: module identity)
export const ShopNav = ({ openCount = 0 }) => {
  const { t } = useLang();
  const { pathname } = useLocation();
  const items = [
    { to: "/dashboard/butikk", label: t("Varer"), Icon: Package, active: pathname === "/dashboard/butikk" || pathname.startsWith("/dashboard/butikk/vare") || pathname === "/dashboard/butikk/ny", testId: "shop-nav-products" },
    { to: "/dashboard/butikk/ordrer", label: t("Ordrer"), Icon: ReceiptText, active: pathname.startsWith("/dashboard/butikk/ordrer"), testId: "shop-nav-orders", count: openCount },
    { to: "/dashboard/butikk/innstillinger", label: t("Innstillinger"), Icon: Settings2, active: pathname.startsWith("/dashboard/butikk/innstillinger"), testId: "shop-nav-settings" },
  ];
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between" data-testid="shop-nav">
      <div className="flex items-center gap-2">
        <span className="inline-flex items-center justify-center w-9 h-9 rounded-xl bg-[hsl(var(--brand-soft))] text-[hsl(var(--brand))]"><Store className="w-5 h-5" /></span>
        <div>
          <div className="flex items-center gap-2">
            <h1 className="text-xl sm:text-2xl font-heading font-semibold tracking-tight">{t("Butikk")}</h1>
            <Badge variant="outline" className="text-[10px] uppercase tracking-wide text-[hsl(var(--info))] border-[hsl(var(--info))]/40" data-testid="shop-module-kicker">{t("Tilleggsmodul")}</Badge>
          </div>
        </div>
      </div>
      <nav className="flex items-center gap-1 rounded-xl border border-border bg-card p-1 self-start sm:self-auto" aria-label={t("Butikk")}>
        {items.map(({ to, label, Icon, active, testId, count }) => (
          <Link
            key={to}
            to={to}
            className={`inline-flex items-center gap-1.5 rounded-lg px-3 py-2 text-sm font-medium transition-colors duration-150 ${active ? "bg-[hsl(var(--accent))] text-foreground" : "text-muted-foreground hover:bg-accent hover:text-foreground"}`}
            aria-current={active ? "page" : undefined}
            data-testid={testId}
          >
            <Icon className="w-4 h-4" />
            {label}
            {count > 0 && <span className="ml-1 inline-flex items-center justify-center min-w-5 h-5 px-1.5 rounded-full bg-primary text-primary-foreground text-[11px] font-semibold tabular-nums" data-testid={`${testId}-count`}>{count}</span>}
          </Link>
        ))}
      </nav>
    </div>
  );
};
